export const SMS_CONSTANTS = {
  MAX_LENGTH: 1600,
  PLACEHOLDER: 'What would you like to say?',
  PLACEHOLDER_UNSUBSCRIBED: 'This person has unsubscribed from SMS messages',
  PLACEHOLDER_NO_PHONE: 'No phone number on record. Please enter a phone number and save this lead to enable texting.',
  PLACEHOLDER_SENDING: 'Sending message...',
};
